module.exports = __webpack_public_path__ + "img/5.dca8c048.jpg";